import React from "react";
import { Page, Text, Document, StyleSheet, View, Image } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
        fontSize: 10,
        padding: 30,
        fontFamily: "Helvetica",
    },
    section: {
        marginBottom: 10,
    },
    header: {
        fontSize: 16,
        marginBottom: 10,
        fontWeight: "bold",
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 4,
    },
    rowTotal: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 4,
        borderTopWidth: 1,
        borderTopColor: "gray",
    },
    column: {
        flexDirection: "column",
    },
    bold: {
        fontWeight: "bold",
    },
    line: {
        borderBottomWidth: 1,
        marginVertical: 10,
    },
    totalRow: {
        flexDirection: "row",
        justifyContent: "flex-end",
        marginTop: 10,
    },
    tableHeader: {
        flexDirection: "row",
        borderBottomWidth: 1,
        marginTop: 10,
        paddingBottom: 4,
        justifyContent: "space-between",
    },
    tableRow: {
        marginTop: 5,
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 2,
    },
    columnDouble: {
        flex: 5,
    },
    columnNormal: {
        flex: 0.5,
    },
    columnNormal2: {
        flex: 1.5,
    },
    end: {
        flex: 1,
        justifyContent: "flex-end",
        textAlign: "right",
    },
    footerText: {
        marginTop: 20,
    },
    contentWrapper: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    footer: {
        fontSize: 8,
        textAlign: 'center',
        lineHeight: 1.5,
        marginTop: 'auto',
        marginBottom: 10,
    },
    boldInline: {
        fontWeight: 'bold',
    },

});



const PDFFile = ({ booking, promo, vatRate, t, i18n }) => {
    const VAT_RATE = vatRate;
    const subtotal = promo ? booking?.products?.reduce((total, product) => total + (product.price || 0), 0) : booking?.subtotal;
    const vatAmount = subtotal * (VAT_RATE / 100);
    const subtotalExclVAT = subtotal / (1 + VAT_RATE / 100);
    const totalVAT = subtotal - subtotalExclVAT;
    const calculatePriceDetails = (price) => {
        const priceExclVAT = price / (1 + VAT_RATE / 100);
        const vatAmount = price - priceExclVAT;
        return {
            priceExclVAT: priceExclVAT.toFixed(2),
            vatAmount: vatAmount.toFixed(2)
        };
    };
    const formatPromo = (promo) => {
        if (!promo) return "N/A";
      
        if (promo.type === "FREE") return t("dashboard:promo.freefac");
      
        let unit = "";
        let prefix = "-";
      
        if (promo.type === "DURATION") {
          unit = " min";
          prefix = "";
        } 
        else if (promo.type === "FLAT_OFF") unit = " CHF";
        else unit = "%";
      
        return `${prefix}${promo.amount}${unit}`;
    };
    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        const currentLang = i18n.language;
        return date.toLocaleDateString(currentLang === "fr" ? "fr-CH" : "en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
            timeZone: "Europe/Zurich"
        });
    };
    const formatDateDot = (isoDate) => {
        const date = new Date(isoDate);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();
        return `${day}.${month}.${year}`;
    };

    const formatTimeHHMM = (isoDate) => {
        const date = new Date(isoDate);
        date.setHours(date.getHours() + 1);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}H${minutes}`;
    };

    const formatEndTime = (startDate, durationMinutes) => {
        const date = new Date(startDate);
        date.setHours(date.getHours() + 1);
        date.setMinutes(date.getMinutes() + durationMinutes);

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${hours}H${minutes}`;
    };

    function formatDateSlash(date) {
        if (!date) return '';
        const d = new Date(date);
        d.setHours(d.getHours() + 1);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    }


    return (
        <Document>
        <Page style={styles.page}>
            <View style={[styles.row, { marginTop: 20 }]}>
                <View style={styles.column}>
                    <Text style={styles.header}>{t("bill:receipt")}</Text>
                    <View style={styles.section}>
                        <View style={styles.row}>
                            <Text>{t("bill:invoice_number")} {booking?.transactions[0]?.invoice_id}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text>{t("bill:receipt_number")} {booking?.transactions[0]?.transaction_id}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text>{t("bill:date_paid")} {formatDate(booking?.transactions[0]?.succeeded_at)}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text>{t("bill:payment_method")} {booking?.transactions[0]?.payment_method}</Text>
                        </View>
                    </View>
                </View>

                    <View style={styles.column}>
                        <Image
                            source={require('../assets/images/logo_fly.png')}
                            style={{ width: 120, height: 85 }}
                        />
                    </View>
                </View>

                <View style={[styles.row, { marginTop: 20 }]}>
                    <View style={styles.column}>
                        <Text style={styles.bold}>flyspa Sàrl</Text>
                        <Text>Rue de Genève 101</Text>
                        <Text>CH-1226 Genève</Text>
                        <Text>Switzerland</Text>
                        <Text>+41 22 548 33 37</Text>
                        <Text>info@flyspa.ch</Text>
                    </View>

                <View style={styles.column}>
                    <Text style={styles.bold}>{t("bill:bill_to")}</Text>
                    <Text>{booking?.client?.extra.full_name}</Text>
                    {/* <Text>{booking?.client?.email}</Text> */}
                    <Text>{booking?.address?.street} {booking?.address?.street_number}</Text>
                    <Text>{booking?.address?.zip_code} {booking?.address?.city}</Text>
                    <Text>{t(`bill:${booking?.address?.country}`)}</Text>
                    </View>

                <View style={styles.column}>
                </View>
            </View>

                {/* Total paid section */}
                <View style={[styles.section, { marginTop: 20 }]}>
                <Text style={[styles.bold, { fontSize: 12 }]}>
                    {booking?.transactions[0]?.currency} {booking?.subtotal} {t("bill:total_paid_message")} {formatDate(booking?.transactions[0]?.succeeded_at)}
                </Text>
                <Text style={styles.footerText}>{t("bill:thank_you")}</Text>
            </View>

                {/* Service table */}
                <View style={styles.tableHeader}>
                <Text style={styles.columnDouble}>{t("bill:description")}</Text>
                <Text style={styles.columnNormal}>{t("bill:quantity")}</Text>
                <Text style={styles.columnNormal2}>{t("bill:price_excl_vat")}</Text>
                <Text style={styles.columnNormal2}>{t("bill:vat")}</Text>
                <Text style={styles.end}>{t("bill:ttc")}</Text>
                </View>
                {booking.isDuo && booking.products.length === 2 ? (
                    booking.products.map((product, index) => {
                        const therapist = booking?.therapists[index];
                        const { priceExclVAT, vatAmount } = calculatePriceDetails(product?.price);

                        return (
                            <View key={index} style={styles.tableRow}>
                                <Text style={styles.columnDouble}>
                                    {product?.category?.title} {product?.duration} min {t("bill:le")} {formatDateSlash(booking?.date)} {t("bill:de")} {formatTimeHHMM(booking?.date)} {t("bill:at")} {formatEndTime(booking?.date, Number(product?.duration))} {t("bill:avec")} {therapist?.firstname}
                                </Text>
                                <Text style={styles.columnNormal}>1</Text>
                                <Text style={styles.columnNormal2}>CHF {priceExclVAT}</Text>
                                <Text style={styles.columnNormal2}>CHF {vatAmount}</Text>
                                <Text style={styles.end}>CHF {product?.price}</Text>
                            </View>
                        );
                    })
                ) : booking.isDuo && booking.products.length === 4 ? (
                    booking.products.map((product, index) => {
                        const isFirstOfPair = index % 2 === 0 && booking?.therapists?.length > 1;
                        const previousProduct = booking?.products[index - 1];
                        const { priceExclVAT, vatAmount } = calculatePriceDetails(product?.price);

                        const previousEndTime = isFirstOfPair
                            ? formatTimeHHMM(booking?.date)
                            : formatEndTime(booking?.date, Number(previousProduct.duration));

                        const startTime = previousEndTime;
                        const endTime = formatEndTime(
                            isFirstOfPair
                                ? booking?.date
                                : new Date(
                                    new Date(booking?.date).getTime() +
                                    Number(previousProduct.duration) * 60000
                                ),
                            Number(product?.duration)
                        );

                        const therapistIndex = index < booking?.products?.length / 2 ? 0 : 1;
                        const therapist = booking?.therapists[therapistIndex];

                        return (
                            <View key={index} style={styles.tableRow}>
                                <Text style={styles.columnDouble}>
                                    {product?.category?.title} {product?.duration} min {t("bill:le")} {formatDateSlash(booking?.date)} {t("bill:de")} {startTime} {t("bill:at")} {endTime} {t("bill:avec")} {therapist?.firstname}
                                </Text>
                                <Text style={styles.columnNormal}>1</Text>
                                <Text style={styles.columnNormal2}>CHF {priceExclVAT}</Text>
                                <Text style={styles.columnNormal2}>CHF {vatAmount}</Text>
                                <Text style={styles.end}>CHF {product?.price}</Text>
                            </View>
                        );
                    })
                ) : (
                    booking.products.map((product, index) => {
                        const isFirst = index === 0;
                        const previousProduct = booking?.products[index - 1];
                        const { priceExclVAT, vatAmount } = calculatePriceDetails(product?.price);
                        const previousEndTime = isFirst
                            ? formatTimeHHMM(booking?.date)
                            : formatEndTime(
                                new Date(booking?.date),
                                booking?.products
                                    .slice(0, index)
                                    .reduce((acc, p) => acc + Number(p.duration), 0)
                            );

                        const startTime = previousEndTime;

                        const endTime = formatEndTime(
                            new Date(booking?.date),
                            booking?.products
                                .slice(0, index + 1)
                                .reduce((acc, p) => acc + Number(p.duration), 0)
                        );

                        return (
                            <View key={index} style={styles.tableRow}>
                                <Text style={styles.columnDouble}>
                                    {product?.category?.title} {product?.duration} min {t("bill:le")} {formatDateSlash(booking?.date)} {t("bill:de")} {startTime} {t("bill:at")} {endTime} {t("bill:avec")} {booking?.therapists[index]?.firstname || booking.therapists[0]?.firstname}
                                </Text>
                                <Text style={styles.columnNormal}>1</Text>
                                <Text style={styles.columnNormal2}>CHF {priceExclVAT}</Text>
                                <Text style={styles.columnNormal2}>CHF {vatAmount}</Text>
                                <Text style={styles.end}>CHF {product.price}</Text>
                            </View>
                        );
                    })

                )}

                {/* Totals */}
                <View style={styles.totalRow}>
                <View style={{ width: 200 }}>
                    <View style={styles.rowTotal}>
                        <Text>{t("bill:subtotal_excl_vat")}</Text>
                        <Text>{booking?.transactions[0]?.currency} {subtotalExclVAT.toFixed(2)}</Text>
                    </View>

                    <View style={styles.rowTotal}>
                        <Text>{t("bill:vat")} ({VAT_RATE}%)</Text>
                        <Text>{booking?.transactions[0]?.currency} {totalVAT.toFixed(2)}</Text>
                    </View>

                    <View style={styles.rowTotal}>
                        <Text>{t("bill:subtotal")} (TTC)</Text>
                        <Text>{booking?.transactions[0]?.currency} {subtotal}</Text>
                    </View>

                    {promo && (
                        <View style={styles.rowTotal}>
                            <Text>{t("bill:promo_application")}</Text>
                            <Text>{formatPromo(promo)}</Text>
                        </View>
                    )}
                    
                    <View style={styles.rowTotal}>
                        <Text>{t("bill:total")} (TTC)</Text>
                        <Text>{booking?.transactions[0]?.currency} {booking?.subtotal}</Text>
                    </View>

                    {/* <View style={[styles.rowTotal, styles.bold]}>
                        <Text>{t("bill:amount_paid")}</Text>
                        <Text>{booking?.transactions[0]?.currency} {booking?.subtotal}</Text>
                    </View> */}
                </View>
            </View>

            {/* FOOTER */}
            <View style={styles.footer}>
                <Text>
                    <Text style={styles.boldInline}>flyspa </Text>
                    101 route de Genève, 1226 Thônex&nbsp;&nbsp;
                    <Text style={styles.boldInline}>{t("bill:footer_email_label")} </Text>info@flyspa.ch&nbsp;&nbsp;
                    <Text style={styles.boldInline}>{t("bill:footer_phone_label")} </Text>+41225483337&nbsp;&nbsp;
                    <Text style={styles.boldInline}>{t("bill:footer_bank_label")} </Text>UBS Switzerland AG
                </Text>

                <Text>
                    <Text style={styles.boldInline}>{t("bill:footer_account_holder")} </Text>flyspa Sàrl&nbsp;&nbsp;
                    <Text style={styles.boldInline}>{t("bill:footer_bic_label")} </Text>UBSWCHZH80A&nbsp;&nbsp;
                    <Text style={styles.boldInline}>{t("bill:footer_iban_label")} </Text>CH38 0024 3243 2348 2701 J&nbsp;&nbsp;
                    <Text style={styles.boldInline}>{t("bill:footer_vat_number")} </Text>CHE-276.713.865
                </Text>

                <Text>
                    <Text style={styles.boldInline}>{t("bill:footer_website_label")} </Text>flyspa.ch
                </Text>
            </View>

        </Page>
    </Document>
);
};

export default PDFFile;